module.exports = __webpack_public_path__ + "media/images/result_sets/icons/easy-bbf5f955cd8014ed1e0e0216d53810a1.svg";